import React, { useMemo, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HelpCircle, LifeBuoy } from 'lucide-react';
import { Drawer } from '@components/Drawer';
import { DOCS, findDocForPath } from '@/docs';
import { formatDateBR } from '@/utils/formatters';
import { MarkdownView } from './MarkdownView';

/** Botão "?" do cabeçalho: abre a documentação da tela atual (src/docs). */
export const HelpButton: React.FC = () => {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const doc = useMemo(() => findDocForPath(DOCS, location.pathname), [location.pathname]);

  if (!doc || location.pathname.startsWith('/help')) return null;

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="p-2 text-slate-600 hover:text-emerald-700 hover:bg-emerald-50 rounded-lg transition-colors"
        title={`Como usar: ${doc.titulo}`}
        aria-label="Ajuda desta tela"
      >
        <HelpCircle size={20} />
      </button>
      <Drawer
        isOpen={open}
        onClose={() => setOpen(false)}
        size="xl"
        title={
          <span className="flex items-center gap-2">
            <HelpCircle size={18} className="text-emerald-600" /> Como usar: {doc.titulo}
          </span>
        }
        footer={
          <div className="flex flex-wrap items-center justify-between gap-2 text-small text-slate-500">
            <span>
              Atualizado em {formatDateBR(doc.atualizado_em)} · versão {doc.versao_funcional}
            </span>
            <Link to={`/help?doc=${encodeURIComponent(doc.file)}`} onClick={() => setOpen(false)} className="text-emerald-700 hover:underline inline-flex items-center gap-1">
              <LifeBuoy size={14} /> Central de ajuda
            </Link>
          </div>
        }
      >
        <MarkdownView source={doc.body} />
      </Drawer>
    </>
  );
};
